const sessionConstants = {
  LOGOUT_REASON: {
    MANUAL: 'MANUAL',
    TIMEOUT: 'TIMEOUT',
  },
};

export { sessionConstants };
